import React from 'react';
import styled from 'styled-components/macro';
import { Row, Col } from '../../../../grid';
import { Image } from '../../../../Image';
import { Heading4, Paragraph } from '../../../../typography';
import TooltipModalLink from '../../../../TooltipModal/TooltipModalLink';

const OfferModal = styled(TooltipModalLink)`
  background: ${({ theme }) => theme.colors.colorYellow};
  color: ${({ theme }) => theme.colors.colorGreyDark};
  font-weight: bold;
  position: relative;
  bottom: 5px;
  max-width: 506px;
  line-height: 1.5em;
  padding: 5px 17px 5px 10px;
  border-radius: 10px;

  @media (max-width: 1199px) {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  @media (max-width: 991px) {
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover {
    color: ${({ theme }) => theme.colors.colorWhite};
    background: ${({ theme }) => theme.colors.colorGreen};
  }
`;

const RenderCampaignNorrebro = ({
  norrebro,
}) => {
  if (norrebro) {
    return (
      <Col xs={12}>
        <OfferModal title="Få 12 gratis glas ved køb af 2 fustager">
          <Row>
            <Col xs={12} md={4} textCenter>
              <Image name="produkter-fadoel.noerrebro-glas-tilbud.png" maxHeight="200px" />
            </Col>
            <Col xs={12} md={8}>
              <Heading4>Få 12 gratis glas ved køb af 2 fustager</Heading4>
              <Paragraph>
                Når du køber mindst 2 fustager fra Nørrebro Bryghus får du 12 gratis glas fra bryggeriet med din ordre.
              </Paragraph>
              <Paragraph>Max 1 omgang gratis glas pr. ordre.</Paragraph>
              <Paragraph>Kampagnen gælder i september og oktober 2023.</Paragraph>
            </Col>
          </Row>
        </OfferModal>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderCampaignNorrebro;
